import {gallery0, gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8, gallery9, gallery10, gallery11, gallery12, gallery13, gallery14, gallery15, gallery16, gallery17, gallery18, gallery19, gallery20, instagram, facebook, tiktok, vale, gni, bca, bankmandiri, bni, bsi, bri, btn,newAvanzaBlack, grandXeniaBlack, xpander, venturer, pajero, newFortuner, alphard, rush, brio, ertiga, jazz, agya, hilux, allNewAvanza, hiace, bus, truck, excavator, wheelloader, driver, vacation, lease, car, video0, video1, video2, video3, video4, video5, videoLandscape1, videoLandscape2, videoLandscape3, videoPotrait1, videoPotrait2, videoPotrait3, videoPotrait4, videoLandscape4, videoPotrait5, innovaReborn, allNewXenia, bukitSalena, danauPoso, danauTambing, matantimali, pantaiBambarano, pantaiKaluku, pusatLaut, saluopaWaterfall, tanjungKarang, bawangGoreng, kacangGoyang, kaledo, kueParanggi, labiaDange, lalampa, miluSiram, sambalIkanRoa, utadada, feature1, feature2, feature3, feature4, feature5, gallery21, gallery22, gallery23, gallery24, gallery25, gallery26, gallery27, gallery28, gallery29, gallery30, gallery31, gallery32, gallery33, gallery34, gallery35, gallery36, gallery37, gallery38, gallery39, gallery40, gallery41, gallery42} from "../assets";


export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "layanan",
    title: "Layanan",
  },
  {
    id: "produk",
    title: "Produk",
  },
  {
    id: "reservasi",
    title: "Syarat & Ketentuan",
  },
  {
    id: "cta",
    title: "Hubungi Kami",
  },
];

export const features = [
  {
    id: "features-1",
    icon: driver,
    title: "Mobil & Pengemudi",
    content: "Kami menyediakan jasa pengemudi yang berpengalaman beserta menyewakan mobil kepada konsumen baik dalam jangka waktu harian ataupun bulanan."
  },
  {
    id: "features-2",
    icon: vacation,
    title: "Liburan Keluarga",
    content: "Kami menyediakan layanan paket liburan keluarga. Kami akan mengantarkan Anda beserta keluarga dengan aman dan nyaman ke tempat liburan favorit anda"
  },
  {
    id: "features-3",
    icon: lease,
    title: "Carter Mobil",
    content: "Kami menyediakan layanan penyewaan mobil kepada konsumen dalam kota Palu ataupun luar kota Palu, baik dalam jangka waktu harian ataupun bulanan."
  },
  {
    id: "features-4",
    icon: car,
    title: "Pengantaran & Penjemputan",
    content: "Kami menyedikan penyewaan mobil untuk melakukan pengantaran atau penjemputan pada bandara atau terminal atau pelabuhan di kota Palu."
  }
]

export const carLists = [
  {
    id: "car-0",
    name: "Toyota Avanza",
    year: "2021",
    type: "G",
    transmition: "Manual / Matic",
    image: newAvanzaBlack,
    brand: "Toyota",
  },
  {
    id: "car-1",
    name: "Daihatsu Xenia",
    year: "2021",
    type: "G",
    transmition: "Manual / Matic",
    image: grandXeniaBlack,
    brand: "Daihatsu",
  },
  {
    id: "car-2",
    name: "Mitsubishi Xpander",
    year: "2021",
    type: "G",
    transmition: "Manual",
    image: xpander,
    brand: "Mitsubishi",
  },
  {
    id: "car-3",
    name: "Toyota Agya",
    year: "2022",
    type: "G",
    transmition: "Manual / Matic",
    image: agya,
    brand: "Toyota"
  },
  {
    id: "car-4",
    name: "Honda Brio",
    year: "2022",
    type: "G",
    transmition: "Manual / Matic",
    image: brio,
    brand: "Honda"
  },
  {
    id: "car-5",
    name: "Honda Jazz",
    year: "2022",
    type: "G",
    transmition: "Manual",
    image: jazz,
    brand: "Honda"
  },
  {
    id: "car-6",
    name: "Innova Reborn",
    year: "2021",
    type: "G",
    transmition: "Manual",
    image: innovaReborn,
    brand: "Toyota",
  },
  {
    id: "car-7",
    name: "Innova Venturer",
    year: "2021",
    type: "Venturer",
    transmition: "Manual",
    image: venturer,
    brand: "Toyota"
  },
  {
    id: "car-8",
    name: "Pajero Sport",
    year: "2021",
    type: "G",
    transmition: "Manual / Matic",
    image: pajero,
    brand: "Mitsubishi"
  },
  {
    id: "car-9",
    name: "Toyota Fortuner",
    year: "2021",
    type: "G",
    transmition: "Manual / Matic",
    image: newFortuner,
    brand: "Toyota"
  },
  {
    id: "car-10",
    name: "Suzuki Ertiga",
    year: "2022",
    type: "G",
    transmition: "Manual",
    image: ertiga,
    brand: "Suzuki"
  },
  {
    id: "car-11",
    name: "Toyota Rush",
    year: "2022",
    type: "G",
    transmition: "Manual",
    image: rush,
    brand: "Toyota"
  },
  {
    id: "car-12",
    name: "All New Avanza",
    year: "2023",
    type: "G",
    transmition: "Manual / Matic",
    image: allNewAvanza,
    brand: "Toyota",
  },
  {
    id: "car-13",
    name: "All New Xenia",
    year: "2023",
    type: "G",
    transmition: "Manual / Matic",
    image: allNewXenia,
    brand: "Daihatsu",
  },
  {
    id: "car-14",
    name: "Toyota Alphard",
    year: "2022",
    type: "G",
    transmition: "Matic",
    image: alphard,
    brand: "Toyota"
  },
  {
    id: "car-15",
    name: "Hilux Double Cabin",
    year: "2023",
    type: "G",
    transmition: "Manual",
    image: hilux,
    brand: "Toyota",
  },
  {
    id: "car-16",
    name: "Toyota Hiace",
    year: "2022",
    type: "G",
    transmition: "Manual",
    image: hiace,
    brand: "Toyota"
  },
  {
    id: "car-17",
    name: "Bus",
    year: "2021",
    type: "G",
    transmition: "Manual",
    image: bus,
    brand: ""
  },
  {
    id: "car-18",
    name: "Truck",
    year: "2022",
    type: "G",
    transmition: "Manual",
    image: truck,
    brand: ""
  },
  {
    id: "car-19",
    name: "Excavator",
    year: "2022",
    type: "Alat Berat",
    transmition: "Manual",
    image: excavator,
    brand: ""
  },
  {
    id: "car-20",
    name: "Wheel Loader",
    year: "2022",
    type: "Alat Berat",
    transmition: "Manual",
    image: wheelloader,
    brand: ""
  },
  
]

export const testimonials = [
  {
    id: "testimoni-1",
    content: "Terimakasih atas pelayanannya maju terus rental sulawesi tengah",
    name: "Iwan Fals",
    city: "Depok"
  },
  {
    id: "testimoni-2",
    content: "Terima kasih untuk pelayanan rental mobil black canyon yang ramah banget, the best dan bikin kita ngerasa perjalanannya mulus banget dari Palu, ke Poso sampai ke Tentena dan kembali lagi di jam yang mepet jadi thank you banget untuk rental mobil black canyon transport.",
    name: "Saykoji",
    city: "Jakarta"
  },
  {
    id: "testimoni-3",
    content: "Saya merasa sangat senang menggunakan jasa rental mobil Black Canyon Transport untuk liburan keluarga saya. Saya merasa sangat terbantu karena perjalanan kami menjadi lebih fleksibel dan efisien",
    name: "Tommy Masri",
    city: "Palu"
  },
  {
    id: "testimoni-4",
    content: "Pelayanan dari tim Black Canyon Transport sangat baik, mereka ramah dan sangat responsif terhadap permintaan dan kebutuhan saya. Sewa mobil murah dan berkualitas hanya di Black Canyon Transport ",
    name: "Andi Nurdin",
    city: "Gorontalo"
  },
  {
    id: "testimoni-5",
    content: "Kondisi mobilnya bersih, bagus, dan terawat dengan baik. Pokoknya recommended. Buat kalian yg mau cari rental mobil murah di kota palu, pake ini aja, dijamin 100% bakalan puas.",
    name: "Ibu Dessy",
    city: "Palu"
  },
]

export const imageGallery = [gallery0, gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8, gallery9, gallery10, gallery11, gallery12,
gallery13, gallery14, gallery15, gallery16, gallery17, gallery18, gallery19, gallery20, gallery21, gallery22, gallery23, gallery24, gallery25, gallery26, gallery27,
gallery28, gallery29, gallery30, gallery31, gallery32, gallery33, gallery34, gallery35, gallery36, gallery37, gallery38, gallery39, gallery40, gallery41, gallery42];

export const videoProperties = [
  {
    id: 0,
    title: "Video-0",
    src: video0,
    desc: "Lorem",
  },
  {
    id: 1,
    title: "Video-1", 
    src: video1,
    desc: "Lorem"
  },
  {
    id: 2,
    title: "Video-2", 
    src: video2,
    desc: "Lorem"
  },
  {
    id: 3,
    title: "Video-3", 
    src: video3,
    desc: "Lorem"
  },
  {
    id: 4,
    title: "Video-4", 
    src: video4,
    desc: "Lorem"
  },
  {
    id: 5,
    title: "Video-5", 
    src: video5,
    desc: "Lorem"
  },
  {
    id: 6,
    title: "Video-6", 
    src: videoLandscape1,
    desc: "Lorem"
  },
  {
    id: 7,
    title: "Video-7", 
    src: videoLandscape2,
    desc: "Lorem"
  },
  {
    id: 8,
    title: "Video-8", 
    src: videoLandscape3,
    desc: "Lorem"
  },
  {
    id: 9,
    title: "Video-9", 
    src: videoLandscape4,
    desc: "Lorem"
  },
  {
    id: 10,
    title: "Video-10", 
    src: videoPotrait1,
    desc: "Lorem"
  },
  {
    id: 11,
    title: "Video-11", 
    src: videoPotrait2,
    desc: "Lorem"
  },
  {
    id: 12,
    title: "Video-12", 
    src: videoPotrait3,
    desc: "Lorem"
  },
  {
    id: 13,
    title: "Video-13", 
    src: videoPotrait4,
    desc: "Lorem"
  },
  {
    id: 14,
    title: "Video-14", 
    src: videoPotrait5,
    desc: "Lorem"
  },
]

export const dataWisata = [
  {
    id: 1,
    name: "Bukit Salena",
    src: bukitSalena,
  },
  {
    id: 2,
    name: "Danau Poso",
    src: danauPoso,
  },
  {
    id: 3,
    name: "Danau Tambing",
    src: danauTambing,
  },
  {
    id: 4,
    name: "Matantimali",
    src: matantimali,
  },
  {
    id: 5,
    name: "Pantai Bambarano",
    src: pantaiBambarano,
  },
  {
    id: 6,
    name: "Pantai Kaluku",
    src: pantaiKaluku,
  },
  {
    id: 7,
    name: "Pusat Laut",
    src: pusatLaut,
  },
  {
    id: 8,
    name: "Air Terjun Saluopa",
    src: saluopaWaterfall,
  },
  {
    id: 9,
    name: "Tanjung Karang",
    src: tanjungKarang,
  },
]

export const dataKuliner = [
  {
    id: 1,
    name: "Bawang Goreng",
    src: bawangGoreng,
  },
  {
    id: 2,
    name: "Kacang Goyang",
    src: kacangGoyang,
  },
  {
    id: 3,
    name: "Kaledo",
    src: kaledo,
  },
  {
    id: 4,
    name: "Kue Paranggi",
    src: kueParanggi,
  },
  {
    id: 5,
    name: "Labia Dange",
    src: labiaDange,
  },
  {
    id: 6,
    name: "Lalampa",
    src: lalampa,
  },
  {
    id: 7,
    name: "Milu Siram",
    src: miluSiram,
  },
  {
    id: 8,
    name: "Sambal Ikan Roa",
    src: sambalIkanRoa,
  },
  {
    id: 9,
    name: "Utadada",
    src: utadada,
  },
]

export const clients = [bni, bsi, gni, bri, btn, vale, bca, bankmandiri]

export const ourFeatures = [
  {
    id: 1,
    src: feature1,
    title: "Mobil Baru",
    desc: "Kami selalu menyediakan mobil terbaik dan terbaru untuk kenyamanan anda."
  },
  {
    id: 2,
    src: feature2,
    title: "Bersih & Terawat",
    desc: "Kondisi mobil dipastikan selalu bersih & terawat, siap untuk menemani hari-hari anda."
  },
  {
    id: 3,
    src: feature3,
    title: "Interior Rapi & Terjaga",
    desc: "Interior yang rapi dan selalu terjaga untuk kenyamanan maksimal selama anda berkendara."
  },
  {
    id: 4,
    src: feature4,
    title: "Perawatan Rutin",
    desc: "Kendaraan selalu mendapatkan servis rutin di bengkel resmi untuk menjamin keamanan anda."
  },
  {
    id: 5,
    src: feature5,
    title: "Driver Berpengalaman",
    desc: "Driver kami terkenal ramah, sopan, berpenampilan rapi, disiplin waktu dan berpengalaman."
  }
]

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/black_canyon_rental_sulteng/",
    name: "Instagram"
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/profile.php?id=100086323136733",
    name: "Facebook"
  },
  {
    id: "social-media-3",
    icon: tiktok,
    link: "https://www.tiktok.com/@blackcanyonrentalsulteng?_t=8Zrgjml04eH&_r=1",
    name: "Tiktok"
  },
]